// Borrador del cuestionario sin enviar, guardado en ESTE navegador para no perderlo si se cierra la pestaña.
// Hallazgo del 10-oct: la llave no llevaba el usuario y salir no la borraba: quien entraba después en el mismo navegador
// veía el nombre, el teléfono y las notas del cliente de otro vendedor. Ahora la llave es por usuario y salir borra todo.
import type { FormaCuestionario, Paso } from './cuestionario.ts';

export const PREFIJO_BORRADOR = 'cotizador:cuestionario-sin-enviar';

const llave = (usuarioId: string) => `${PREFIJO_BORRADOR}:${usuarioId}`;

export function leerBorradorLocal(usuarioId: string): { forma: FormaCuestionario; paso: Paso } | null {
  try {
    const s = window.localStorage.getItem(llave(usuarioId));
    return s ? (JSON.parse(s) as { forma: FormaCuestionario; paso: Paso }) : null;
  } catch {
    return null;
  }
}

export function guardarBorradorLocal(usuarioId: string, forma: FormaCuestionario, paso: Paso): void {
  try {
    window.localStorage.setItem(llave(usuarioId), JSON.stringify({ forma, paso }));
  } catch {
    /* sin almacenamiento: no pasa nada */
  }
}

export function borrarBorradorLocal(usuarioId: string): void {
  try {
    window.localStorage.removeItem(llave(usuarioId));
  } catch {
    /* nada */
  }
}

/** Al salir: borra el borrador de TODOS los usuarios de este navegador (y la llave vieja, sin usuario). */
export function borrarTodosLosBorradores(): void {
  try {
    const ls = window.localStorage;
    const llaves: string[] = [];
    for (let i = 0; i < ls.length; i++) {
      const k = ls.key(i);
      if (k && k.startsWith(PREFIJO_BORRADOR)) llaves.push(k);
    }
    for (const k of llaves) ls.removeItem(k);
  } catch {
    /* nada */
  }
}
